import { render, staticRenderFns } from "./LotteryOrder.vue?vue&type=template&id=2e15b4ce&scoped=true"
import script from "./LotteryOrder.vue?vue&type=script&lang=js"
export * from "./LotteryOrder.vue?vue&type=script&lang=js"
import style0 from "./LotteryOrder.vue?vue&type=style&index=0&id=2e15b4ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e15b4ce",
  null
  
)

export default component.exports